<template>
    <div
        class="tag"
        :data-theme="theme">
        <span>{{label}}</span>
    </div>
</template>

<script>
    export default {
        name: 'CoreTag',
        props: {
            theme: {
                type: String,
                default: 'blue'
            },
            label: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
.tag {
    display: inline-flex;
    align-self: flex-start;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-weight: 600;

    @extend %tag-themes;
}

%tag-themes {
    &[data-theme=primary] {
        background-color: var(--tag-primary);
        color: var(--tag-primary-text);
    }

    &[data-theme=blue] {
        background-color: var(--system-blue);
        color: var(--system-blue);

        @include breakpoint(md) {
            background-color: var(--system-blue-25);
        }
    }

    &[data-theme=green] {
        background-color: var(--system-green);
        color: var(--system-green);

        @include breakpoint(md) {
            background-color: var(--system-green-50);
        }
    }

    &[data-theme=orange] {
        background-color: var(--system-orange-50);
        color: var(--system-orange);
    }

    &[data-theme=red] {
        background-color: var(--system-red-50);
        color: var(--system-red);
    }
}
</style>
